import React, { useContext } from "react";
import TimezoneSelect from "react-timezone-select";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

const TimezoneOption = (props) => {
  const { options, setOptions } = props;

  const isxTheme = useTheme();

  return (
    <FormControl
      variant="standard"
      fullWidth={true}
      sx={{
        flexDirection: "column",
        margin: 3,
        width: "calc(100% - 48px)",
      }}
    >
      <FormLabel component="legend">Timezone</FormLabel>
      <Box sx={{ marginTop: 1, zIndex: 10 }}>
        <TimezoneSelect
          placeholder="Default to current timezone"
          isClearable
          value={options.timezone ?? {}}
          onChange={(tz) => {
            setOptions({
              timezone: tz?.value ?? tz,
            });
          }}
          theme={(theme) => ({
            ...theme,
            colors: {
              ...theme.colors,
              primary: isxTheme.palette.primary.main,
              primary25: isxTheme.palette.primary.contrastText,
            },
          })}
        />
      </Box>
    </FormControl>
  );
};

export default TimezoneOption;
